import localization from '../../../shared/strings';

const l10n = localization.OPERATIONS;

export default function mapOperationLabel(operationType) {
  return (l10n.labels && l10n.labels[operationType]) || operationType || '';
}
